module.exports = __webpack_public_path__ + "static/assets/07d7c7d457fbc7d7d686663097e9fd85.png";